export const MAPBOX_STYLE = 'mapbox://styles/mapbox/streets-v11';
export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1Ijoicm9oYW4yNTk5IiwiYSI6ImNqd3B4cjNseTI3anAzenA2Nmk4ZnYzOWUifQ.3r3MLJcFyZZP--tL0hFyWw';
export const GOOGLE_MAPS_API_TOKEN = 'AIzaSyBKtmiMnPzYWHTWRqzmRsiX0Djr3kWNSRg';
